// extracted by mini-css-extract-plugin
export default {"applianceContainer":"ApplianceOverview_applianceContainer__qRyya","addApplianceButton":"ApplianceOverview_addApplianceButton__VWXZO"};